import type { SendExpertAssistMessage } from "@expert/shared-types";
import type { JSX } from "react";

import { useReactAnalytics } from "@asurion-core/eventualize-react";
import { Button, Group, Text } from "@mantine/core";

interface AskAssistProps {
    callSid?: string;
    extraData?: Record<string, unknown>;
    prompt: string;
    sendMessage: SendExpertAssistMessage;
}

export function AskAssist({ callSid, extraData, prompt, sendMessage }: AskAssistProps): JSX.Element | null {
    const { dispatcher } = useReactAnalytics();

    const enhancedDispatcher = callSid ? dispatcher.withIdentities({ CallSid: callSid }) : dispatcher;

    const onClick = () => {
        void enhancedDispatcher.dispatchBusinessEvent(`Click_Guide_AskAssist`, {
            button: "AskAssist",
            prompt,
            ...extraData,
        });
        sendMessage({
            text: prompt,
            type: "Expert",
            source: "GuideAskAssist",
        });
    };

    return (
        <Group gap="xxs">
            <Text c="dark.0" size="xs">
                Need help?
            </Text>
            <Button bg="transparent" onClick={onClick} p="0" size="xs">
                <Text c="dark.0" size="xs" td="underline">
                    Ask Assist
                </Text>
            </Button>
        </Group>
    );
}
